export default {
  alias      : 'regulations_files',
  route      : '/app/normatividad/regulations_files',
  hash       : false,
  store      : false,
  name       : 'tip_description',
  key        : 'id',
  selectable : true,
  relations  : [
    {
      attribute : 'file_idregulation',
      alias     : 'regulation',
      module    : 'regulation',
      hasMany   : false
    }
  ],
  maxRelationsResolve : 3,
  default             : {
    id                : null,
    file_idregulation : null,
    file_ruta         : null,
    file_tomo         : null,
    file_nro_tipo     : 1,
    file_status       : 2,//0:malo,1:bueno,2:revisar
    file_statusfile   : null,
    file_size         : null,
    file_user         : null,
    file_name         : null,
    file_type         : null,
    file_md5          : null,
    created_at        : null,
    updated_at        : null,
  }
}
